import React from 'react'
import ModalSection from 'components/ModalSection'
import { Bold } from 'components/Text'
import FormMultiField from 'components/FormMultiField'
import styled from '@emotion/styled'
import { Form, Dropdown, spacer } from 'stylist'
import Container from 'components/Container'
import EstimateGrid from './EstimateGrid'
import Qualifications from './Qualifications'
import GetPrices from './GetPrices'
import { formToRequestData, fieldErrors } from 'utils/form'
import SummaryBox from '../../SummaryBox'
import { postEstimate } from 'utils/api'

const Wrapper = styled(Container)`
  & {
    padding: 0;
    max-width: none;

    h5.main-heading {
      margin-bottom: 0;
    }

    .form-section {
      padding-bottom: ${spacer(8)};
      flex: 1;
    }

    .summary-section {
      max-width: 420px;
      width: 30%;
      margin-left: ${spacer(4)};
    }

    .get-prices button {
      margin-top: ${spacer(8)};
      width: 100%;
    }
  }
`

class EstimateForm extends React.Component {
  state = {
    validateOnChange: false,
    disableSubmit: false,
    noProvidersFound: false
  }

  defaults = {
    completions: '',
    interviewLength: '',
    fieldLength: '',
    incidence: '',
    questions: {},
    quotas: {},
    pii: null,
    locale: null,
    zipFile: []
  }

  goToResults = (form, results) => {
    const { history, location } = this.props
    history.replace({
      pathname: '/form',
      search: location.search,
      state: {
        form
      }
    })
    history.push({
      pathname: '/results',
      search: location.search,
      state: {
        results,
        form
      }
    })
  }

  priceFound = resp =>
    // If any vendor returned a price, continue
    Object.keys(resp.data).length > 0

  handleSubmit = form => {
    const data = formToRequestData(form)
    this.setState({ disableSubmit: true })

    return postEstimate(data).then(resp => {
      if (this.priceFound(resp)) {
        this.goToResults(form, resp.data)
      } else {
        this.setState({ noProvidersFound: true, disableSubmit: false })
      }
    })
  }

  validate = values => {
    if (this.state.noProvidersFound) {
      // Clear response error state when any field changes
      this.setState({ noProvidersFound: false })
    }
    return fieldErrors(values)
  }

  render() {
    const { location } = this.props
    return (
      <Form
        initialValues={(location.state && location.state.form) || this.defaults}
        validateOnChange={this.state.validateOnChange}
        validate={this.validate}
        onSubmit={this.handleSubmit}
      >
        <Wrapper>
          <ModalSection className="form-section">
            <Container>
              <h5 className="main-heading">
                <Bold>Who do you want to complete your survey?</Bold>
              </h5>
            </Container>
            <EstimateGrid />
            <FormMultiField
              names={['questions', 'quotas', 'locale', 'zipFile']}
            >
              {fields => (
                <Qualifications
                  questionsField={fields.questions}
                  quotasField={fields.quotas}
                  locale={fields.locale.value}
                  zipFileField={fields.zipFile}
                />
              )}
            </FormMultiField>
          </ModalSection>
          <ModalSection className="summary-section">
            <Form.Field
              render={({ form: { values } }) => <SummaryBox {...values} />}
            />
            <Container className="get-prices">
              <GetPrices
                disabled={this.state.disableSubmit}
                noProviders={this.state.noProvidersFound}
                onClick={() => this.setState({ validateOnChange: true })}
              />
            </Container>
          </ModalSection>
        </Wrapper>
      </Form>
    )
  }
}

export default EstimateForm



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/index.js